import React, { useEffect, useState } from 'react';
import { Checkbox } from '../ui';
import { ModalFooter } from './modalFooter';

const ColumnList = ({
  selectedColumns,
  columnList,
  handleColumnSave,
  handleClose,
}) => {
  const [fields, setFieldValue] = useState({});
  useEffect(() => {
    if (selectedColumns && selectedColumns.length) {
      const fieldValues = {};
      selectedColumns.forEach((item) => {
        fieldValues[item] = true;
      });
      setFieldValue(fieldValues);
    }
  }, [selectedColumns]);

  const handleOkClick = () => {
    // fields
    const data = Object.keys(fields).filter((key) => !!fields[key]);

    handleColumnSave(data);
  };

  return (
    <div className="flex flex-col gap-6 max-lg:w-full max-lg:px-6  max-h-[calc(100vh-80px)] overflow-scroll scrollbar">
      <ul className="grid lg:grid-cols-2 gap-3 ">
        {columnList.map((item) => {
          return (
            <li
              key={item.name}
              className="flex bg-powdergrey justify-between py-3 px-6 gap-3 rounded-lg"
            >
              <div>{item.label}</div>
              <div className="items-top flex space-x-2">
                <Checkbox
                  id={item.name}
                  checked={!fields[item.name]}
                  onCheckedChange={(value) => {
                    setFieldValue((prev) => {
                      return { ...prev, [item.name]: !value };
                    });
                  }}
                />
              </div>
            </li>
          );
        })}
      </ul>
      <div className="flex justify-center items-center pt-5">
        <ModalFooter
          handleCancelClick={() => handleClose(false)}
          handleOkClick={handleOkClick}
          className="max-lg:flex-col max-lg:col-reverse max-lg:w-full"
        />
      </div>
    </div>
  );
};

export default ColumnList;
